import { useLazyQuery, useMutation } from '@apollo/client';
import { FEATURE_FLAGS_QUERY, SET_FEATURE_FLAGS, IS_FEATURE_FLAG_ENABLED_QUERY } from './FeatureFlags.helpers';
import { useEffect, useState } from 'react';

export const useSetFeatureFlags = () => {
  const [setFeatureFlags, { data, loading, error }] = useMutation<{ setFeatureFlags: boolean }>(SET_FEATURE_FLAGS);

  return {
    setFeatureFlags,
    data,
    loading,
    error,
  };
};

export const useUserFeatureFlag = (featureFlagAlias: string) => {
  const [queryFeatureFlag, { loading, error, data }] = useLazyQuery<{
    featureFlags: { enabled: boolean; name: string }[];
  }>(FEATURE_FLAGS_QUERY, { ssr: false });
  const [featureFlag, setFeatureFlag] = useState<
    | {
        enabled: boolean;
        name: string;
      }
    | undefined
  >();

  useEffect(() => {
    if (data) {
      const featureFlagData = data.featureFlags.find(({ name }) => name === featureFlagAlias);
      setFeatureFlag(featureFlagData);
    }
  }, [data, featureFlagAlias]);
  return { queryFeatureFlag, loading, error, featureFlag };
};

export const useLazyIsFeatureFlagEnabled = () => {
  const [checkFeatureFlag, { loading, error, data }] = useLazyQuery<{ isFeatureFlagEnabled: boolean }>(
    IS_FEATURE_FLAG_ENABLED_QUERY,
    { ssr: false }
  );

  return {
    checkFeatureFlag: (flagAlias: string) => checkFeatureFlag({ variables: { flagAlias } }),
    isEnabled: data?.isFeatureFlagEnabled ?? false,
    loading,
    error,
  };
};
